/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import {
    object, shape, string,
} from 'prop-types';
import mbpLogger from 'mbp-logger';
import { GRAPHQL_ENV } from '../../../../gql';
import { getCurrencyData } from '../../../../../state/ducks/App/App-Selectors';
import { setLocale } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import DealOfWeek from './DealOfWeek';

const  GraphqlSaleEntry = ({
    brand, blockData, collectionCode, currencyData,
}) => {
    const FINDCATEGORY_BY_ID = gql`
    query {
        findCategoryById(brand: "${brand['domain-name']}", id: "${collectionCode}", environment: "${GRAPHQL_ENV}", currency: "${currencyData?.currencyName}", locale: "${setLocale()}", productOptions:{page:1}) {
            products {
                id, name, image {name, path}, partNumber,
                availability {
                    deliveryMessage
                },
                prices {
                    currency
                    type
                    value
                }
                skuPriceRange {
                    sale {type, value},
                    retail {type, value}
                }
                seo {
                    url
                    title
                }
            }
        }
    }`;

    return (

        <Query query={FINDCATEGORY_BY_ID}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }
                if (error) {
                    mbpLogger.logError({
                        query: FINDCATEGORY_BY_ID,
                        component: ' GraphqlSaleEntry.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        query: FINDCATEGORY_BY_ID,
                        component: ' GraphqlSaleEntry.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data.findCategoryById || !data.findCategoryById.products) {
                    mbpLogger.logWarning({
                        query: FINDCATEGORY_BY_ID,
                        component: ' GraphqlSaleEntry.js',
                        message: 'No product returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                // getting the firstproduct
                const graphqlProducts = data?.findCategoryById?.products?.[0] || null;
                const pageBlocks = Object.entries(blockData)?.map((listData) => ({ [listData?.[0]]: listData?.[1] }));

                return <DealOfWeek firstProduct={graphqlProducts} pageBlocks={pageBlocks} />;
            }}
        </Query>
    );
};

GraphqlSaleEntry.propTypes = {
    brand: shape({
        code: string,
    }).isRequired,
    blockData: object.isRequired,
    collectionCode: string.isRequired,
    currencyData: shape({
        currencyName: string,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    currencyData: getCurrencyData(state),
});

export default connect(mapStateToProps)(GraphqlSaleEntry);
